module.exports = __webpack_public_path__ + "img/4.bac0eeb1.jpg";